import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import AppSdkFilter from "../../components/filters/AppSdkFilter/AppSdkFilter";
import AppSdkFilterResult from "../../components/filters/AppSdkFilter/AppSdkFilterResult";
import { SdkUpgradeView } from "../../components/upgrade-views/SdkUpgradeView";
import type { AppOperatingSystem, IAppsSDKsFilterItem } from "../../types/commonFiltersDto";
import type { IAppsSDKsFilterDescriptionDto } from "../../types/descriptionDto";
import { appsFilterCategoryMap } from "../../types/filterCategory";
import { getSdkFilterByPlatform } from "../../utils";

const createSdkFilter = (
    sdksFilter: IAppsSDKsFilterDescriptionDto,
    appOs: AppOperatingSystem,
): SearchFilterInstance => ({
    key: "sdks",
    trackingName: "App SDKs",
    apiCategory: "appsFilters",
    category: appsFilterCategoryMap.apps,
    title: { key: "si.find_apps.filters.sdks.title" },
    tooltipText: { key: "si.find_apps.filters.sdks.tooltip" },
    gateStatus: !salesSettingsHelper.isAppsSdksAvailable ? { type: "upgrade", view: SdkUpgradeView } : undefined,
    filter: new FilterPanelBaseFilter<IAppsSDKsFilterItem[], IAppsSDKsFilterDescriptionDto>({
        options: getSdkFilterByPlatform(sdksFilter, appOs) || {
            sdksDescriptions: [],
            inclusionOptions: [],
            operatorOptions: [],
        },
    }),
    filterView: AppSdkFilter,
    filterResultView: AppSdkFilterResult,
});

export default createSdkFilter;
